import { render, staticRenderFns } from "./General.vue?vue&type=template&id=bf8db20e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf8db20e')) {
      api.createRecord('bf8db20e', component.options)
    } else {
      api.reload('bf8db20e', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=bf8db20e&", function () {
      api.rerender('bf8db20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/forms/General.vue"
export default component.exports